import { Component, Input, Output, EventEmitter, OnChanges, OnDestroy, Inject, SimpleChanges } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';

import * as fromRoot from '../../../reducers';
import * as olci from '../../../actions/olci';
import * as tracking from '../../../actions/tracking';
import { constants } from '../../../constants/constants';
import { GatingServices } from '../services/gating.services';
import { BookingService } from '../services/booking.service';

@Component({
    selector: 'app-user-menu',
    templateUrl: 'user-menu.component.html',
    standalone: false
})
export class UserMenuComponent implements OnChanges, OnDestroy {
	@Input() public bundle: any = [];
	@Output() public showMenuChange = new EventEmitter<boolean>();

	public showMenuValue = false;

	public exitModal;

	public currentLanguage: any;
	public _currentLangSubscription: Subscription;

	constructor(
		public bookingService: BookingService,
		private readonly gatingServices: GatingServices,
		@Inject('UrlService') public urlService: any,
		private readonly store: Store<fromRoot.AppState>
	) {
		this._currentLangSubscription = this.store.pipe(select(fromRoot.getCurrentlanguage)).subscribe(res => {
			this.currentLanguage = res;
		});

		this.exitModal = constants.MODAL.EXIT;
	}

	@Input()
	get showMenu() {
		return this.showMenuValue;
	}

	set showMenu(value) {
		this.showMenuValue = value;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['showMenu']) {
			this.showMenuChange.emit(this.showMenuValue);
		}
	}

	gaSettings(event: any) {
		event.preventDefault();
		this.store.dispatch(new olci.OpenModalAction({ name: this.exitModal, url: this.gatingServices.getGASettingsURL() }));
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('menu dropdown: settings'));
	}

	gaCruises(event: any) {
		event.preventDefault();
		this.store.dispatch(new olci.OpenModalAction({ name: this.exitModal, url: this.gatingServices.getGACruisesURL() }));
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('menu dropdown: upcoming cruises'));
	}

	getFaq() {
		this.showMenuChange.emit(false);
		const faqLink = this.urlService.faq();
		setTimeout(() => {
			window.open(faqLink, '_blank');
		}, 300); // to give time for the drop down to close before opening the new faq window.
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('menu dropdown: faq'));
	}

	showLanguageSelector() {
		const modalName = constants.MODAL.LANGUAGE;
		this.store.dispatch(new olci.OpenModalAction({ name: modalName, url: '' }));
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('menu dropdown: language'));
	}

	signOut(event: any) {
		event.preventDefault();
		this.store.dispatch(new olci.OpenModalAction({ name: this.exitModal, url: this.gatingServices.getBrandURL(), logoutFromGA: true }));
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('menu dropdown: sign out'));
	}

	getCurtesyHolds() {
		const urlLink = this.urlService.curtesyHolds();
		this.store.dispatch(new olci.OpenModalAction({ name: this.exitModal, url: urlLink }));
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('menu dropdown: sign out'));
	}

	getRoyalGifts() {
		const urlLink = this.urlService.royalGifts();
		this.store.dispatch(new olci.OpenModalAction({ name: this.exitModal, url: urlLink }));
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('menu dropdown: sign out'));
	}

	getPastCruises() {
		const urlLink = this.urlService.pastCruises();
		this.store.dispatch(new olci.OpenModalAction({ name: this.exitModal, url: urlLink }));
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('menu dropdown: sign out'));
	}

	ngOnDestroy() {
		this._currentLangSubscription.unsubscribe();
	}
}
